module.exports = "/images/slide-qs-t-10.jpg";